<form #delegationForm="ngForm">
  <div class="wrapper">
    @if (errorMessage()) {
      <div class="errorMessage">
        <pre>{{ errorMessage() }}</pre>
      </div>
    }
    <div class="delegationListContainer">
      <div class="toolbar">
        <span class="spacer"></span>
        <h3 class="toolbarLabel">Existing Delegations</h3>
        <span class="spacer"></span>
        <span>
          <button matButton="text" [disabled]="isBusy()" (click)="newDelegation()">
            <span>
              <mat-icon class="size-16">add</mat-icon>
              <label>Add</label>
            </span>
          </button>
        </span>
      </div>
      <table class="reportTable">
        <thead>
          <tr>
            <td class="tableCell headerCell centeredCell">Start Date</td>
            <td class="tableCell headerCell centeredCell">End Date</td>
            <td class="tableCell headerCell centeredCell">Delegate</td>
          </tr>
        </thead>
        @if (delegations() && delegations().length > 0) {
          @for (delegation of delegations(); track delegation) {
            <tr class="selectableRow" [class.selectedRow]="selectedDelegation() && delegation.id === selectedDelegation().id"
              (click)="selectDelegation(delegation)">
              <td class="tableCell centeredCell">{{ formatDisplayDate(delegation.startTime) | date:'MM/dd/yyyy':'UTC' }}
              </td>
              <td class="tableCell centeredCell">{{ formatDisplayDate(delegation.endTime) | date:'MM/dd/yyyy':'UTC' }}
              </td>
              <td class="tableCell">{{ delegation.delegateDisplay }}</td>
            </tr>
          }
        }
        @if (!delegations() || delegations().length === 0) {
          <tr>
            <td colspan="3">
              No Delegations found
            </td>
          </tr>
        }
      </table>
    </div>
    @if (selectedDelegation(); as selectedDelegation) {
      <div class="delegationDetail">
        <h3 class="detailHeader">Delegation Detail</h3>
        <div class="inputRow">
          <span class="inputLabel">
            <label>Delegate</label>
          </span>
          <span class="inputField">
            <select name="delegateInput" id="delegateInput" class="inputField" required
              [(ngModel)]="selectedDelegation.delegate" #delegateInput="ngModel">
              <option value="undefined" disabled>Please Select</option>
              @for (user of delegationUsers(); track user) {
                <option [value]="user.code">{{ user.description }}</option>
              }
            </select>
          </span>
        </div>
        <div class="inputRow">
          <span class="inputLabel">
            <label>Start Date</label>
          </span>
          <span class="inputField">
            <input [matDatepicker]="startTimePicker" name="startDateInput"
              [value]="formatDisplayDate(selectedDelegation.startTime)" (dateChange)="setStartTime($event.value)"/>
            <mat-datepicker-toggle [for]="startTimePicker"></mat-datepicker-toggle>
            <mat-datepicker id="startTimePicker" name="startTimePicker" #startTimePicker></mat-datepicker>
          </span>
        </div>
        <div class="inputRow">
          <span class="inputLabel">
            <label>End Date</label>
          </span>
          <span class="inputField">
            <input [matDatepicker]="endTimePicker" name="endDateInput"
              [value]="formatDisplayDate(selectedDelegation.endTime)" (dateChange)="setEndTime($event.value)"/>
            <mat-datepicker-toggle [for]="endTimePicker"></mat-datepicker-toggle>
            <mat-datepicker id="endTimePicker" name="endTimePicker" #endTimePicker></mat-datepicker>
          </span>
        </div>
        <div class="toolbar">
          <span>
            <button matButton="text" [disabled]="!delegationForm.valid || isBusy()" (click)="endNow()">
              <span>
                <mat-icon class="size-16">report</mat-icon>
                <label>End Now</label>
              </span>
            </button>
          </span>
          <span class="spacer"></span>
          <span>
            <button matButton="text" [disabled]="isBusy()" (click)="cancelUpdate()">
              <span>
                <mat-icon class="size-16">block</mat-icon>
                <label>Cancel</label>
              </span>
            </button>
          </span>
          <span class="spacer"></span>
          <span>
            <button matButton="text" [disabled]="!delegationForm.valid || isBusy()" (click)="saveDelegation()">
              <span>
                <mat-icon class="size-16">done</mat-icon>
                <label>Save</label>
              </span>
            </button>
          </span>
        </div>
      </div>
    }
  </div>
  @if (isBusy()) {
    <div class="busyIndicator">
      <div class="busyContents">
        <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
        <label class="busyLabel">Please Wait...</label>
      </div>
    </div>
  }
</form>

